import { IUser, IUserChat } from '@/types/models';
import {
  buildCompanyTeamMap,
  filterChatUsersBySearch,
  getTeamUserByUid,
} from '@/utils/chatHelpers';
import { useMemo, useState } from 'react';
import useDebouncedValue from './useDebouncedValue';

const useTeamMembersSearch = <T extends { user: IUserChat }>(
  sortedChat: T[] | null,
  companyTeam: IUser[] | null | undefined
) => {
  const [membersSearch, setMembersSearch] = useState('');
  const debouncedMembersSearch = useDebouncedValue(membersSearch);

  const companyTeamById = useMemo(
    () => buildCompanyTeamMap(companyTeam),
    [companyTeam]
  );

  const filteredSortedChat = useMemo(
    () =>
      filterChatUsersBySearch(
        sortedChat,
        companyTeamById,
        debouncedMembersSearch
      ),
    [sortedChat, companyTeamById, debouncedMembersSearch]
  );

  const showNoMembersFound =
    !!debouncedMembersSearch.trim() && !filteredSortedChat?.length;

  const getTeamUser = (uid: string) => getTeamUserByUid(companyTeamById, uid);

  return {
    membersSearch,
    setMembersSearch,
    filteredSortedChat,
    showNoMembersFound,
    getTeamUser,
  };
};

export default useTeamMembersSearch;
